import React, { useEffect, useState } from 'react';
import './style.scss';
import { BOOTSTRAP_ICONS } from 'assets/js/bootstrap-icons';
import { CustomButton, Popup, Input } from 'components';
 
export const IconsUtility = (props) => {
 
    const [iconsSet, setIconsSet] = useState(BOOTSTRAP_ICONS);
    const [displayPopup, setDisplayPopup] = useState(false);
    const [selectedIcon, setSelectedIcon] = useState(props.icon);
    const [filterIcon, setFilterIcon] = useState(null);
 
    useEffect(()=> {
        if(selectedIcon) {
            setSelectedIcon(<SelectedIconTemplate iconName={props.icon}/>);
        }
    },[props.icon])
 
    //ON ICON SELECT
    const onIconChoose = (e, icon) => {
        e.preventDefault();
        setSelectedIcon(<SelectedIconTemplate iconName={icon} />);
        setDisplayPopup(false);
        props.iconChooseCallback(icon);
    }
 
    //SEARCH ICONS CALLBACK
    useEffect(() => {
        if (filterIcon) {
            let filtredIcons = BOOTSTRAP_ICONS.filter((icon) => icon.includes(filterIcon.toLowerCase()));
            setIconsSet(filtredIcons)
        } else {
            setIconsSet(BOOTSTRAP_ICONS);
        }
    }, [filterIcon]);
 
    //ON ICON CANCEL SELECT
    const onIconCancel = () => {
        setSelectedIcon(null);
        props.iconChooseCallback(null)
    }
 
    //SELECTED ICON TEMPLATE
    const SelectedIconTemplate = (props) => {
        const { iconName } = props;
        return <div>
            <span className="choosen-icon-template" onClick={() => setDisplayPopup(true)}>
                <i className={iconName} /> &nbsp; {iconName}
            </span>
            <i className="mx-2 bi bi-x-circle icon-template-cleaner" onClick={onIconCancel} />
        </div>
    }
 
    return (
        <>
            {
                !selectedIcon ?
                    <CustomButton
                        className="p-button-info w-100"
                        type="text"
                        label={<span> <i className="bi bi-file-image" /> Icons Chooser</span>}
                        onClick={(e) => { e.preventDefault(); setDisplayPopup(true) }} /> : <span className="d-flex">Icon : &nbsp;{selectedIcon}</span>
            }
            <Popup
                header="Icons Utiliy"
                visible={displayPopup}
                style={{ width: '50vw' }}
                onHide={() => setDisplayPopup(false)}>
                <>
                    <Input
                        placeholder="Search custom icon"
                        value={filterIcon}
                        onChange={(e) => {
                            setFilterIcon(e.target.value)
                        }} />
                    <div className="scroll-container my-3" style={{ height: "60vh" }}>
                        {
                            iconsSet.map((icon => {
                                return <span className="icon-item p-2" onClick={(e) => {onIconChoose(e, icon); e.preventDefault()}}>
                                    <i className={icon} style={{ fontSize: "23px" }} /></span>
                            }))
                        }
                    </div>
                </>
            </Popup>
        </>
    );
}